<itl-wizard-page [ngClass]="{'ios': isIOs}" isSinglePage="true" showOnlyCancel="true" (cancelClicked)="cancel()">
  <div id="viewerContent"></div>
</itl-wizard-page>
